<template>
  <div class="flex align-items-center gap-2 text-sm">
    <span
      class="material-symbols-outlined notranslate error-message text-sm"
      translate="no"
    >
      info
    </span>
    <span class="error-message">
      {{ msg }}
    </span>
  </div>
</template>

<script setup>
import { defineProps } from "vue";

defineProps({
  msg: {
    type: String,
    required: true,
  },
});
</script>
